/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../index.js";
export function IconSpotifyConnect(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M14.5 8a6.468 6.468 0 0 0-1.3-3.9l1.2-.9C15.405 4.537 16 6.2 16 8c0 1.8-.595 3.463-1.6 4.8l-1.2-.9A6.468 6.468 0 0 0 14.5 8zM8 1.5a6.5 6.5 0 1 0 3.25 12.13.75.75 0 1 1 .75 1.3 8 8 0 1 1 0-13.86.75.75 0 1 1-.75 1.298A6.467 6.467 0 0 0 8 1.5z\'/><path d=\'M11.259 8c0-.676-.228-1.296-.611-1.791l1.187-.918c.579.749.924 1.69.924 2.709a4.41 4.41 0 0 1-.925 2.709l-1.186-.918c.383-.495.61-1.115.61-1.791zM8.75 4.115l-4.139 2.39a1.727 1.727 0 0 0 0 2.99l4.139 2.39v-7.77z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M21 12c0-2.027-.67-3.895-1.799-5.4l1.6-1.2A10.956 10.956 0 0 1 23 12c0 2.475-.819 4.762-2.2 6.6l-1.599-1.2A8.956 8.956 0 0 0 21 12zm-9-9a9 9 0 0 0 0 18 8.955 8.955 0 0 0 4.5-1.203 1 1 0 1 1 1 1.73A10.954 10.954 0 0 1 12 23C5.925 23 1 18.075 1 12S5.925 1 12 1c2.002 0 3.882.536 5.5 1.472a1 1 0 0 1-1 1.731A8.954 8.954 0 0 0 12 3z\'/><path d=\'M17 12a4.979 4.979 0 0 0-1.042-3.056L17.54 7.72A6.974 6.974 0 0 1 19 12c0 1.61-.545 3.096-1.46 4.28l-1.582-1.224A4.974 4.974 0 0 0 17 12zm-4-5-5.327 3.077a2.223 2.223 0 0 0 0 3.846L13 17V7z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : true;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconSpotifyConnect is deprecated and will be archived soon. Use IconSpotifyConnect instead.
 */
export function Experimental__IconSpotifyConnect(props) {
  return /*#__PURE__*/React.createElement(IconSpotifyConnect, props);
}